// src/features/media/schemas/VideoForm.schema.ts

import { z } from 'zod';
import { VIDEO_CONSTRAINTS, REF_ID_PATTERN, MEDIA_STATE_TYPES } from '@/lib/constants/media';

export const VideoFormSchema = z.object({
  title: z.string()
    .min(VIDEO_CONSTRAINTS.TITLE_MIN, 'Title is required')
    .max(VIDEO_CONSTRAINTS.TITLE_MAX, `Max ${VIDEO_CONSTRAINTS.TITLE_MAX} characters`),

  descShort: z.string()
    .max(VIDEO_CONSTRAINTS.DESC_SHORT_MAX, `Max ${VIDEO_CONSTRAINTS.DESC_SHORT_MAX} characters`),

  descLong: z.string()
    .max(VIDEO_CONSTRAINTS.DESC_LONG_MAX, `Max ${VIDEO_CONSTRAINTS.DESC_LONG_MAX} characters`),

  refId: z.string()
    .max(VIDEO_CONSTRAINTS.REF_ID_MAX, `Max ${VIDEO_CONSTRAINTS.REF_ID_MAX} characters`)
    .refine(
      (val) => !val || REF_ID_PATTERN.test(val),
      'Only letters, numbers, hyphens, and underscores allowed'
    ),

  published: z.number(),

  availStart: z.number().nullable(),
  availEnd: z.number().nullable(),

  relatedLinkUrl: z.string()
    .max(VIDEO_CONSTRAINTS.RELATED_LINK_URL_MAX, `Max ${VIDEO_CONSTRAINTS.RELATED_LINK_URL_MAX} characters`)
    .refine(
      (val) => !val || /^https?:\/\/.+/.test(val),
      'Must be a valid URL starting with http:// or https://'
    ),

  relatedLinkText: z.string()
    .max(VIDEO_CONSTRAINTS.RELATED_LINK_TEXT_MAX, `Max ${VIDEO_CONSTRAINTS.RELATED_LINK_TEXT_MAX} characters`),

  mediaStateType: z.enum(MEDIA_STATE_TYPES),

  notes: z.string()
    .max(VIDEO_CONSTRAINTS.NOTES_MAX, `Max ${VIDEO_CONSTRAINTS.NOTES_MAX} characters`),

  tags: z.array(z.string()),
});

export type VideoFormData = z.infer<typeof VideoFormSchema>;
